import { useAtom } from 'jotai';
import { linePlanEntityAtom } from '~/atoms/linePlanEntity';
export const useLinePlanEntity = () => {
    const [linePlanEntity, setLinePlanEntity] = useAtom(linePlanEntityAtom);
    return {
        linePlanEntity,
        setLinePlanEntity
    };
};
